exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1aP6h{height:100%}._1aP6h,._2b6FC,._5Dbpa{width:100%}._5Dbpa{height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:center center;object-position:center center}._2FDmG{color:#fff;padding:5px 0 5px 16px;padding:5px 0 5px 1rem;width:95%;overflow:hidden;display:-webkit-box;color:#f8f8f8;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-height:1.5px;color:#dbd9d9;font-family:Lato;font-size:22.4px;font-size:1.4rem;font-weight:400;letter-spacing:.67px;line-height:19px;margin-top:5px}._1Wj9j,._2FDmG{position:absolute}._1Wj9j{color:#969696;font-size:smaller;padding:0 16px;padding:0 1rem;bottom:16px;bottom:1rem;line-height:33px}._1NsNJ{background-color:#16161a;position:relative}", ""]);

// exports
exports.locals = {
	"ahref": "_1aP6h",
	"image__wrapper": "_2b6FC",
	"image__thumbnail": "_5Dbpa",
	"title": "_2FDmG",
	"date": "_1Wj9j",
	"text__container": "_1NsNJ"
};